import request from '@/utils/request/bus'

// 查询操作日志列表
export function list(query) {
  return request({
    // request/bus 的 baseURL 是 /bus/，这里不要再带前导 '/'
    url: 'ecenter/system/operlog/list',
    method: 'get',
    params: query
  })
}

// 导出操作日志
// 与 eCenter-ui 的 http_download 一致：POST + JSON body，后端直接返回文件流
export function exportOperlog(data) {
  return request({
    url: 'ecenter/system/operlog/export',
    method: 'post',
    data,
    responseType: 'blob',
    headers: { repeatSubmit: false }
  })
}
